import React from "react";
import MyRouter from "routers/index";

function App() {
  return (
    <div className="bg-white text-black text-lg bg-glass-bg bg-full bg-no-repeat bg-[length:120%_100%]">
      <MyRouter />
    </div>
  );
}

export default App;
